import React from 'react';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { tabsOpened } from 'store/actions/tabs';
import { IModuleNavigationData } from 'types/navigation';

const ModuleNavigationRenderer: React.FC<ICellRendererParams> = (params) => {
  const dispatch = useDispatch();

  // Get navigation data directly from the cell value
  const navigationData: IModuleNavigationData | undefined = params.value;

  if (!navigationData) return null;

  const handleClick = () => {
    if (navigationData.ref > 0 && navigationData.refId > 0) {
      dispatch(
        tabsOpened({
          refId: navigationData.ref,
          search: navigationData.refId.toString(),
          courseId: navigationData.courseId,
          subModuleId: navigationData.subModuleId,
          navigationPath: navigationData.navigationPath,
        }),
      );
    }
  };

  const isClickable = navigationData.ref > 0 && navigationData.refId > 0 && navigationData.courseId >= 0;

  return (
    <LoadIconContainer onClick={isClickable ? handleClick : undefined} $clickable={isClickable}>
      <i className="fas fa-external-link-alt" />
    </LoadIconContainer>
  );
};

const LoadIconContainer = styled.span<{ $clickable?: boolean }>`
  cursor: ${(props) => (props.$clickable ? 'pointer' : 'default')};
  color: ${(props) => (props.$clickable ? '#1890ff' : '#ccc')};
  transition: color 0.2s ease;

  &:hover {
    color: ${(props) => (props.$clickable ? '#1565c0' : '#ccc')};
  }
`;

export default ModuleNavigationRenderer;
